'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/** *****
 *
 *
 *  Hey there. Glad you found your way here. Please be sure to alphabetize your constants.
 *
 *
 ****** */
var AUDIO = exports.AUDIO = 'audio';
var AUDIO_BANDWIDTH_LIMIT = exports.AUDIO_BANDWIDTH_LIMIT = '64000';
var AUDIO_INPUT = exports.AUDIO_INPUT = 'audioinput';
var AUDIO_STATUS = exports.AUDIO_STATUS = 'audioStatus';
var ALTERNATE_REDIRECT_TRUE = exports.ALTERNATE_REDIRECT_TRUE = 'alternateRedirect=true';
var ANSWER = exports.ANSWER = 'ANSWER';
var ALERT = exports.ALERT = 'alert';
var ACTIVE = exports.ACTIVE = 'ACTIVE';

var BUSY = exports.BUSY = 'BUSY';

var CALL = exports.CALL = 'call';
var CREATED = exports.CREATED = 'CREATED';
var CONFLICT = exports.CONFLICT = 'CONFLICT';
var CORRELATION_ID = exports.CORRELATION_ID = 'correlationId';
var CONVERSATION_URL = exports.CONVERSATION_URL = 'CONVERSATION_URL';
var CONVERSATIONS = exports.CONVERSATIONS = 'conversations';
var CALENDAR = exports.CALENDAR = 'calendar';
var CALENDAR_EVENTS_API = exports.CALENDAR_EVENTS_API = 'calendarEvents';
var CMR_MEETINGS = exports.CMR_MEETINGS = 'cmrmeetings';
var CLAIM = exports.CLAIM = 'claim';
var CONTROLS = exports.CONTROLS = 'controls';
var CONTENT = exports.CONTENT = 'content';

var DEVELOPMENT = exports.DEVELOPMENT = 'development';
var DECLINE = exports.DECLINE = 'decline';

var ERROR = exports.ERROR = 'ERROR';

var GET = exports.GET = 'GET';

var HECATE = exports.HECATE = 'hecate';

var IDLE = exports.IDLE = 'IDLE';
var ICE_TIMEOUT = exports.ICE_TIMEOUT = 1000;
var ICE_FAIL_TIMEOUT = exports.ICE_FAIL_TIMEOUT = 3000;
var IN_LOBBY = exports.IN_LOBBY = 'IN_LOBBY';
var IN_MEETING = exports.IN_MEETING = 'IN_MEETING';
var INCOMING = exports.INCOMING = 'INCOMING';
var INTENT_TO_JOIN = exports.INTENT_TO_JOIN = 2423005;

var JOINED = exports.JOINED = 'JOINED';

var LEAVE = exports.LEAVE = 'leave';
var LOCAL = exports.LOCAL = 'local';
var LOCI = exports.LOCI = 'loci';
var LOCUS_ID = exports.LOCUS_ID = 'LOCUS_ID';
var LOCUS_URL = exports.LOCUS_URL = 'locusUrl';
var LEFT = exports.LEFT = 'LEFT';

var MEETING_LINK = exports.MEETING_LINK = 'MEETING_LINK';
var MEETINGS = exports.MEETINGS = 'Meetings';
var MEETING = exports.MEETING = 'MEETING';
var MEETING_CENTER = exports.MEETING_CENTER = 'MEETING_CENTER';
var MEETING_ID = exports.MEETING_ID = 'MEETING_ID';
var MEETINGINFO = exports.MEETINGINFO = 'meetingInfo';
var MEDIA_SIP_URI = exports.MEDIA_SIP_URI = 'MEDIA_SIP_URI';
var MEDIA = exports.MEDIA = 'media';
var MODERATOR_TRUE = exports.MODERATOR_TRUE = true;
var MODERATOR_FALSE = exports.MODERATOR_FALSE = false;
var MEDIA_PEER_CONNECTION_NAME = exports.MEDIA_PEER_CONNECTION_NAME = 'MediaPeerConnection';

var NOT_IN_MEETING = exports.NOT_IN_MEETING = 'NOT_IN_MEETING';
var NONE = exports.NONE = 'NONE';

var ONE_ON_ONE = exports.ONE_ON_ONE = 'ONE_ON_ONE';
var OFFER = exports.OFFER = 'OFFER';
var OBSERVE = exports.OBSERVE = 'OBSERVE';
var OUTGOING = exports.OUTGOING = 'OUTGOING';
var ONLINE = exports.ONLINE = 'online';
var OTHER = exports.OTHER = 'OTHER';

var PARTICIPANT = exports.PARTICIPANT = 'participant';
var PERSONAL_ROOM = exports.PERSONAL_ROOM = 'PERSONAL_ROOM';
var PUT = exports.PUT = 'PUT';
var POST = exports.POST = 'POST';

var RETRY_TIMEOUT = exports.RETRY_TIMEOUT = 3000;
var REMOTE = exports.REMOTE = 'remote';
var REQUESTED = exports.REQUESTED = 'REQUESTED';
var _ANSWER_ = exports._ANSWER_ = 'answer';
var _ERROR_ = exports._ERROR_ = 'error';
var _DATA_ = exports._DATA_ = 'data';
var _CLOSED_ = exports._CLOSED_ = 'closed';
var RTC_CONFIGURATION_FIREFOX = exports.RTC_CONFIGURATION_FIREFOX = { iceServers: [], bundlePolicy: 'max-compat' };
var RTC_CONFIGURATION = exports.RTC_CONFIGURATION = { iceServers: [] };
var RESOURCE_ROOM = exports.RESOURCE_ROOM = 'RESOURCE_ROOM';
var READY = exports.READY = 'ready';
var RECEIVE_ONLY = exports.RECEIVE_ONLY = 'RECVONLY';

var SIP_URI = exports.SIP_URI = 'SIP_URI';
var STOP = exports.STOP = 'STOP';
var SHARE_PEER_CONNECTION_NAME = exports.SHARE_PEER_CONNECTION_NAME = 'SharePeerConnection';
var SELF = exports.SELF = 'SELF';
var SEND_RECEIVE = exports.SEND_RECEIVE = 'SENDRECV';

var TEMP_SIP_URI = exports.TEMP_SIP_URI = 'TEMP_SIP_URI';
var TYPE = exports.TYPE = 'type';

var USE_URI_LOOKUP_FALSE = exports.USE_URI_LOOKUP_FALSE = 'useUriLookup=false';
var USER = exports.USER = 'USER';
var UNKNOWN = exports.UNKNOWN = 'UNKNOWN';

var VALID_PMR_ADDRESS = exports.VALID_PMR_ADDRESS = /([a-z0-9][-a-z0-9, '.']{0,62})@([a-z0-9][-a-z0-9, '.']{0,62})\.webex\.com/i;
var VALID_PMR_LINK = exports.VALID_PMR_LINK = /(https:\/\/)?([a-z0-9][-a-z0-9, '.']{0,62})\.webex\.com\/(meet|join)\/([a-z0-9][-a-z0-9, '.']{0,62})\/?/i;
var VALID_PIN = exports.VALID_PIN = /([0-9]{4,6})/;
var VIDEO = exports.VIDEO = 'video';
var VIDEO_BANDWIDTH_LIMIT = exports.VIDEO_BANDWIDTH_LIMIT = '4000000';
var VIDEO_INPUT = exports.VIDEO_INPUT = 'videoinput';
var VIDEO_STATUS = exports.VIDEO_STATUS = 'videoStatus';

var WEBEX_DOT_COM = exports.WEBEX_DOT_COM = 'webex.com';
var WEBEX_MEETING = exports.WEBEX_MEETING = 'WEBEX_MEETING';
var WAIT = exports.WAIT = 'WAIT';

var ERROR_DICTIONARY = exports.ERROR_DICTIONARY = {
  INTENT_TO_JOIN: {
    NAME: 'IntentToJoinError',
    MESSAGE: 'The meeting is locked. This is expected behavior. Call #join again with hostPin and/or moderator option',
    CODE: 1
  },
  JOIN_MEETING: {
    NAME: 'JoinMeetingError',
    MESSAGE: 'Meeting:index#join --> Error joining the call on getLocalMedia',
    CODE: 2
  },
  RECONNECTION: {
    NAME: 'ReconnectionError',
    MESSAGE: 'There was an error in the reconnection flow, the call may not reconnect, disconnect and dial again.',
    CODE: 3
  }
};

// TODO:  move all api params to API section
var API = exports.API = {
  CALLIOPEDISCOVERY: 'calliopeDiscovery',
  LOCUS: 'locus'
};

var DIALER_REGEX = exports.DIALER_REGEX = {
  // modified from https://github.com/kirm/sip.js base
  // and with https://tools.ietf.org/html/rfc3261
  // requires the @ symbol
  SIP_ADDRESS: /^(sips?)?:?(?:([^\s>:@]+)(?::([^\s@>]+))?@)([\w\-.]+)(?::(\d+))?((?:;[^\s=?>;]+(?:=[^\s?;]+)?)*)(?:\?(([^\s&=>]+=[^\s&=>]+)(&[^\s&=>]+=[^\s&=>]+)*))?$/,
  // standard telephony num regex
  PHONE_NUMBER: /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/
};

var CALENDAR_EVENTS = exports.CALENDAR_EVENTS = {
  CREATE: 'event:calendar.meeting.create',
  UPDATE: 'event:calendar.meeting.update',
  CREATE_MINIMAL: 'event:calendar.meeting.create.minimal',
  UPDATE_MINIMAL: 'event:calendar.meeting.update.minimal',
  DELETE: 'event:calendar.meeting.delete'
};

var FLOOR_ACTION = exports.FLOOR_ACTION = {
  GRANTED: 'GRANTED',
  RELEASED: 'RELEASED'
};

var MEETING_STATE_MACHINE = exports.MEETING_STATE_MACHINE = {
  TRANSITIONS: {
    ERROR: 'error',
    START: 'start',
    JOIN: 'join',
    JOINED: 'joined',
    LOCAL: 'local',
    CONNECT: 'connect',
    ESTABLISH: 'establish',
    LEAVE: 'leave',
    END: 'end',
    CLEAN: 'clean'
  },
  STATES: {
    IDLE: 'IDLE',
    INCOMING: 'INCOMING',
    DIALING: 'DIALING',
    ON_GOING: 'ON_GOING',
    CONNECTING_MEDIA_LOCAL: 'CONNECTING_MEDIA_LOCAL',
    CONNECTING_MEDIA_REMOTE: 'CONNECTING_MEDIA_REMOTE',
    ESTABLISHED_MEDIA: 'ESTABLISHED_MEDIA',
    TERMINATING: 'TERMINATING',
    ENDED: 'ENDED',
    ERROR: 'ERROR'
  }
};

var LOCUS = exports.LOCUS = {
  STATE: {
    INACTIVE: 'inactive'
  },
  SEQUENCE: {
    UN_DEF: 'undef',
    EMPTY: 'empty',
    DEF: 'def',
    NA: 'na',
    RANGE_START: 'rangeStart',
    RANGE_END: 'rangeEnd'
  },
  SYNCDEBUG: 'sync_debug'
};

var LOCUSEVENT = exports.LOCUSEVENT = {
  LOCUS_MERCURY: 'event:locus',

  // update the tp unit status
  CONTROLS_UPDATED: 'locus.controls_updated',

  // delta events
  DIFFERENCE: 'locus.difference',

  // screen sharing
  FLOOR_GRANTED: 'locus.floor_granted',
  FLOOR_RELEASED: 'locus.floor_released',

  // Roap
  MESSAGE_ROAP: 'locus.message.roap',

  // Join events
  PARTICIPANT_JOIN: 'locus.participant_joined',
  PARTICIPANT_LEFT: 'locus.participant_left',
  PARTICIPANT_DECLINED: 'locus.participant_declined',
  PARTICIPANT_UPDATED: 'locus.participant_updated',
  PARTICIPANT_CONTROLS_UPDATED: 'locus.participant_controls_updated',
  PARTICIPANT_ROLES_UPDATED: 'locus.participant_roles_updated',
  PARTICIPANT_AUDIO_MUTED: 'locus.participant_audio_muted',
  PARTICIPANT_AUDIO_UNMUTED: 'locus.participant_audio_unmuted',
  PARTICIPANT_VIDEO_MUTED: 'locus.participant_video_muted',
  PARTICIPANT_VIDEO_UNMUTED: 'locus.participant_video_unmuted',

  RECORDING_STARTED: 'locus.recording_started',
  RECORDING_START_FAILED: 'locus.recording_start_failed',
  RECORDING_STOPPED: 'locus.recording_stopped',

  SELF_CHANGED: 'locus.self_changed'
};

var RECONNECTION = exports.RECONNECTION = {
  STATE: {
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETE: 'COMPLETE',
    FAILURE: 'FAILURE',
    DEFAULT_TRY_COUNT: 0,
    DEFAULT_STATUS: ''
  }
};

// TODO: do we want to scope by meeting, members when they come off those objects themselves?
var EVENT_TRIGGERS = exports.EVENT_TRIGGERS = {
  MEETINGS_READY: 'meetings:ready',
  MEDIA_AUDIO_CHANGED: 'media:audioChanged',
  MEDIA_VIDEO_CHANGED: 'media:videoChanged',
  MEDIA_READY: 'media:ready',
  MEDIA_STOPPED: 'media:stopped',
  MEDIA_UPDATE: 'media:update',
  STATS_UPDATE: 'stats:update',
  MEETING_ADDED: 'meeting:added',
  MEETING_REMOVED: 'meeting:removed',
  MEETING_RINGING: 'meeting:ringing',
  MEETING_SELF_LOBBY_WAITING: 'meeting:self:lobbyWaiting',
  MEETING_SELF_GUEST_ADMITTED: 'meeting:self:guestAdmitted',
  MEMBERS_UPDATE: 'members:update',
  MEMBERS_CONTENT_UPDATE: 'members:content:update',
  MEMBERS_HOST_UPDATE: 'members:host:update',
  MEMBERS_SELF_UPDATE: 'members:self:update',
  MEETING_RECONNECTION_STARTING: 'meeting:reconnectionStarting',
  MEETING_RECONNECTION_SUCCESS: 'meeting:reconnectionSuccess',
  MEETING_RECONNECTION_FAILURE: 'meeting:reconnectionFailure'
};

var EVENT_STATS_MAP = exports.EVENT_STATS_MAP = {
  BYTES_SENT: 'bytesSent',
  BYTES_RECEIVED: 'bytesReceived'
};

var EVENT_TYPES = exports.EVENT_TYPES = {
  SELF: 'self',
  OTHER: 'other',
  LOCAL: 'local',
  REMOTE: 'remote',
  REMOTE_SHARE: 'remoteShare',
  LOCAL_SHARE: 'localShare',
  ERROR: 'error'
};

var DELTAEVENT = exports.DELTAEVENT = {
  GT: 'GT',
  CF: 'CF',
  EQ: 'EQ',
  LT: 'LT'
};

var MEETING_AUDIO_STATE_MACHINE = exports.MEETING_AUDIO_STATE_MACHINE = {
  TRANSITIONS: {
    TOGGLE: 'toggle',
    INIT: 'init'
  },
  STATES: {
    MUTE_SELF: 'SELF_AUDIO_OFF',
    UNMUTE_SELF: 'SELF_AUDIO_ON'
  }
};

var MEETING_VIDEO_STATE_MACHINE = exports.MEETING_VIDEO_STATE_MACHINE = {
  TRANSITIONS: {
    TOGGLE: 'toggle',
    INIT: 'init'
  },
  STATES: {
    MUTE_SELF: 'SELF_VIDEO_OFF',
    UNMUTE_SELF: 'SELF_VIDEO_ON'
  }
};

var SDP = exports.SDP = {
  A_CONTENT_SLIDES: 'a=content:slides',
  ROLLBACK: 'rollback',
  HAVE_LOCAL_OFFER: 'have-local-offer',
  STABLE: 'stable',
  OFFER: 'offer',
  M_LINE: 'm=',
  MAX_FS_8160: 'max-fs=8160',
  B_LINE: 'b=TIAS',
  CARRIAGE_RETURN: '\r\n',
  BAD_MEDIA_PORTS: [9, 0]
};

var ICE_STATE = exports.ICE_STATE = {
  CHECKING: 'checking',
  CONNECTED: 'connected',
  FAILED: 'failed',
  DISCONNECTED: 'disconnected'
};

var RESOURCE = exports.RESOURCE = {
  CLUSTERS: 'clusters',
  REACHABILITY: 'reachability',
  LOCI: 'loci'
};

var REACHABILITY = exports.REACHABILITY = {
  localStorage: 'reachability.result'
};

var ROAP = exports.ROAP = {
  ROAP_TRANSITIONS: {
    STEP: 'step'
  },
  ROAP_TYPES: {
    OFFER: 'OFFER',
    ANSWER: 'ANSWER',
    OK: 'OK',
    ERROR: 'ERROR',
    SHUTDOWN: 'SHUTDOWN',
    OFFER_REQUEST: 'OFFER_REQUEST'
  },
  ROAP_STATE: {
    INIT: 'INIT',
    WAIT_RX_OFFER: 'WAIT_RX_OFFER',
    WAIT_RX_ANSWER: 'WAIT_RX_ANSWER',
    WAIT_RX_OK: 'WAIT_RX_OK',
    WAIT_TX_OFFER: 'WAIT_TX_OFFER',
    WAIT_TX_ANSWER: 'WAIT_TX_ANSWER',
    WAIT_TX_OK: 'WAIT_TX_OK',
    IDLE_LOCAL_OFFER: 'IDLE_LOCAL_OFFER',
    IDLE_REMOTE_OFFER: 'IDLE_REMOTE_OFFER',
    GLARE: 'GLARE',
    ERROR: 'ERROR'
  },
  ROAP_SIGNAL: {
    RX_OFFER: 'RX_OFFER',
    TX_OFFER: 'TX_OFFER',
    RX_ANSWER: 'RX_ANSWER',
    TX_ANSWER: 'TX_ANSWER',
    RX_OK: 'RX_OK',
    TX_OK: 'TX_OK',
    GLARE_RESOLVED: 'GLARE_RESOLVED'
  },
  RECEIVE_ROAP_MSG: 'RECEIVE_ROAP_MSG',
  SEND_ROAP_MSG: 'SEND_ROAP_MSG',
  SEND_ROAP_MSG_SUCCESS: 'SEND_ROAP_MSG_SUCCESS',
  RESET_ROAP_STATE: 'RESET_ROAP_STATE',
  RECEIVE_CALL_LEAVE: 'RECEIVE_CALL_LEAVE',
  ROAP_MERCURY: 'event:locus.message.roap',
  ROAP_VERSION: '2',
  RX_: 'RX_',
  TX_: 'TX_'
};

var EVENTS = exports.EVENTS = {
  ROAP_OK: 'ROAP_OK',
  ROAP_ANSWER: 'ROAP_ANSWER',
  SELF_UNADMITTED_GUEST: 'SELF_UNADMITTED_GUEST',
  SELF_ADMITTED_GUEST: 'SELF_ADMITTED_GUEST',
  CONVERSATION_URL_UPDATE: 'CONVERSATION_URL_UPDATE',
  DESTROY_MEETING_DECLINE_1_1: 'DESTROY_MEETING_DECLINE_1_1',
  LOCUS_INFO_UPDATE_PARTICIPANTS: 'LOCUS_INFO_UPDATE_PARTICIPANTS',
  LOCUS_INFO_UPDATE_HOST: 'LOCUS_INFO_UPDATE_HOST',
  LOCUS_INFO_UPDATE_MEDIA_SHARES: 'LOCUS_INFO_UPDATE_MEDIA_SHARES',
  LOCUS_INFO_UPDATE_SELF: 'LOCUS_INFO_UPDATE_SELF',
  LOCUS_INFO_UPDATE_URL: 'LOCUS_INFO_UPDATE_URL'
};

// TODO: move to config?
var DEFAULT_GET_STATS_FILTER = exports.DEFAULT_GET_STATS_FILTER = {
  types: ['track', 'transport', 'candidate-pair', 'outbound-rtp', 'outboundrtp', 'inbound-rtp', 'inboundrtp']
};
var DEFAULT_EVENT_VIDEO_SEND_KEYS = exports.DEFAULT_EVENT_VIDEO_SEND_KEYS = ['rtpOutVideo', 'rtcOutVideo', 'rtcTransVideo'];
var DEFAULT_EVENT_AUDIO_SEND_KEYS = exports.DEFAULT_EVENT_AUDIO_SEND_KEYS = ['rtpOutAudio', 'rtcOutAudio', 'rtcTransAudio'];
var DEFAULT_EVENT_VIDEO_RECEIVE_KEYS = exports.DEFAULT_EVENT_VIDEO_RECEIVE_KEYS = ['rtpInVideo', 'rtcInVideo', 'rtcTransVideo'];
var DEFAULT_EVENT_AUDIO_RECEIVE_KEYS = exports.DEFAULT_EVENT_AUDIO_RECEIVE_KEYS = ['rtpInAudio', 'rtcInAudio', 'rtcTransAudio'];
var DEFAULT_TRANSFORM_KEYS = exports.DEFAULT_TRANSFORM_KEYS = ['rtpOutVideo', 'rtpOutAudio', 'rtpInVideo', 'rtpInAudio', 'rtcOutAudio', 'rtcOutVideo', 'rtcInAudio', 'rtcInVideo', 'rtcTransAudio', 'rtcTransVideo', 'rtcCandidatePairAudio', 'rtcCandidatePairVideo'];
var DEFAULT_TRANSFORM_REGEX = exports.DEFAULT_TRANSFORM_REGEX = {
  rtpOutVideo: {
    regex: new RegExp('^(?:RTC)?[Oo]utbound_?[Rr][Tt][Pp]_?[Vv]ideo')
  },
  rtpOutAudio: {
    regex: new RegExp('^(?:RTC)?[Oo]utbound_?[Rr][Tt][Pp]_?[Aa]udio')
  },
  rtpInVideo: {
    regex: new RegExp('^(?:RTC)?[Ii]nbound_?[Rr][Tt][Pp]_?[Vv]ideo')
  },
  rtpInAudio: {
    regex: new RegExp('^(?:RTC)?[Ii]nbound_?[Rr][Tt][Pp]_?[Aa]udio')
  },
  rtcOutAudio: {
    regex: new RegExp('^RTCMediaStreamTrack_(?:local|sender)_'),
    profiler: {
      type: 'kind',
      value: 'audio'
    }
  },
  rtcOutVideo: {
    regex: new RegExp('^RTCMediaStreamTrack_(?:local|sender)_'),
    profiler: {
      type: 'kind',
      value: 'video'
    }
  },
  rtcInAudio: {
    regex: new RegExp('^RTCMediaStreamTrack_(?:remote|receiver)_'),
    profiler: {
      type: 'kind',
      value: 'audio'
    }
  },
  rtcInVideo: {
    regex: new RegExp('^RTCMediaStreamTrack_(?:remote|receiver)_'),
    profiler: {
      type: 'kind',
      value: 'video'
    }
  },
  rtcTransAudio: {
    regex: new RegExp('^RTCTransport_[Aa]udio')
  },
  rtcTransVideo: {
    regex: new RegExp('^RTCTransport_[Vv]ideo')
  },
  rtcCandidatePairAudio: {
    regex: new RegExp('^RTCIceCandidatePair_'),
    decider: 'nominated',
    selector: true,
    profiler: {
      type: 'transportId',
      value: 'audio'
    }
  },
  rtcCandidatePairVideo: {
    regex: new RegExp('^RTCIceCandidatePair_'),
    decider: 'nominated',
    selector: true,
    profiler: {
      type: 'transportId',
      value: 'video'
    }
  }
};
var DEFAULT_STATS_INTERVAL = exports.DEFAULT_STATS_INTERVAL = 1000;
var DEFAULT_STATS_HISTORY_MAX = exports.DEFAULT_STATS_HISTORY_MAX = 1800;
var DEFAULT_EXCLUDED_STATS = exports.DEFAULT_EXCLUDED_STATS = ['timestamp', 'ssrc', 'priority'];
//# sourceMappingURL=constants.js.map
